import axiosInstance from 'Api';

const communityList = () => {
    return axiosInstance.get("travelcost/community-list");
};

const CoordinatorInstellingenService = {
    communityList
};
export default CoordinatorInstellingenService;